import styled from "styled-components";

export const SlideStyled = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;
